import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Row, Col } from "reactstrap"
import ContainerMax from "components/shared/ContainerMax"
import { GatsbyImage } from "gatsby-plugin-image";
import Text from "components/shared/Text"

const FooterSponsers = (props) => {
	const data = useStaticQuery(graphql`
		query {
			allWp {
				edges {
					node {
						...optionsFragment
					}
				}
			}
		}
	`)

	const { footerSponserTitle, sponserLogoGroup } = data.allWp.edges[0]?.node?.options?.acfOptions

	return (
		<ContainerMax className="py-4">
			{footerSponserTitle &&
				<Text $xl $uppercase $bold $center $baseheading className="py-4">
					{footerSponserTitle}
				</Text>
			}
			{sponserLogoGroup && sponserLogoGroup.map((group, i) => {
				return(
					<Row className="justify-content-center align-items-center text-center" key={i}>
						{group.title &&
							<Col xs={12}>
								<Text $lg  $baseSubtitle >{group.title}</Text>
							</Col>
						}
						{group.footerSponserLogos && group.footerSponserLogos.map((logo, i) => {
							return (
								<Col xs={10} md={3} xl={2} className="pb-3" key={i}>
									<div style={{ maxWidth: "200px", margin: "0 auto" }}>
										{logo.url !== null ? (
											<a href={logo.url} target="_blank" rel="noopener noreferrer" style={{ display: "block" }}>
												<GatsbyImage
													image={logo.image.localFile.childImageSharp.gatsbyImageData}
													alt={logo.image.altText} />
											</a>
										) : (
											<GatsbyImage
												image={logo.image.localFile.childImageSharp.gatsbyImageData}
												alt={logo.image.altText} />
										)}
									</div>
								</Col>
							)
						})}
					</Row>
				)
			})}
		</ContainerMax>
	)
}

export default FooterSponsers